import React from 'react';
import style from './style.module.scss';
import { GoBackButton } from '../../'

const NavigationSection = () => {
    return (
        <div className={style.wrapper}>
            <GoBackButton label="Go Back" />
        </div>
    );
};

export default NavigationSection;